<app-si-dialog [isLoading]="isLoading$ | async" #dialog header="FILTERS APPLIED TO THIS JOB" cancelButtonText="Close" [hideSaveButton]="true" modalFooterClasses="si-dialog__footer--centered">
  <ng-template appDialogBody>
    <div class="p-6" *ngIf="data">
      <ng-container [ngSwitch]="data?.fetchFilters?.fetchFilterType">
        <ng-container *ngSwitchCase="hubspotEnrichmentFetchFilterTypeEnum.EMPTY">
          <span class="font-bold">All records included</span>
        </ng-container>

        <ng-container *ngSwitchCase="hubspotEnrichmentFetchFilterTypeEnum.CUSTOM">
          <div class="flex flex-wrap -mx-2">
            <div class="flex-none w-1/6 px-2">
              <span>List:</span>
            </div>
            <div class="flex-none w-5/6 px-2">
              <div class="flex flex-wrap -mx-2">
                <div class="flex-none w-5/12 px-2">
                  <span class="font-bold">{{listName$ | async}}</span>
                </div>
              </div>
            </div>
          </div>
        </ng-container>

        <ng-container *ngSwitchCase="hubspotEnrichmentFetchFilterTypeEnum.FIELD">
          <app-field-query-filter
            [fields]="fields$ | async"
            [isReadonly]="true"
            [(ngModel)]="data.fetchFilters.fieldQueryFilters.filters"
          ></app-field-query-filter>
        </ng-container>
      </ng-container>
    </div>
  </ng-template>

  <ng-template appDialogFooter>
    <button matButton="outlined" type="button" (click)="dialog.onClose()">Close</button>
  </ng-template>
</app-si-dialog>
